import type { Deliberation, DeliberationType } from '@/types/deliberation'

export function isSecondeDeliberation(type: DeliberationType | string | undefined | null): boolean {
	return type === 'seconde'
}

export function getDeliberationSessionLabel(type: DeliberationType | string | undefined | null): string {
	return isSecondeDeliberation(type) ? '2ème session' : '1ère session'
}

/** Libellés des documents d'issue (feuille EC / résultats session) selon 1re ou 2e délibération. */
export interface DeliberationOutcomeDocumentLabels {
	feuilleDocumentTitle: string
	feuilleEmptyMessage: string
	feuilleModalTitle: string
	feuilleModalDescription: string
	feuillePdfFilenamePrefix: string
	resultatsModalDescription: string
	resultatsNonAdmisSectionTitle: string
}

export function getDeliberationOutcomeDocumentLabels(
	type: DeliberationType | string | undefined | null
): DeliberationOutcomeDocumentLabels {
	if (isSecondeDeliberation(type)) {
		return {
			feuilleDocumentTitle: 'Tableau des EC à reprendre',
			feuilleEmptyMessage: 'Aucun étudiant avec EC à reprendre',
			feuilleModalTitle: 'Feuille des EC à reprendre',
			feuilleModalDescription:
				'Tableau des étudiants devant reprendre des EC l\'année suivante, classés par EC',
			feuillePdfFilenamePrefix: 'EC à reprendre',
			resultatsModalDescription:
				'Liste des étudiants admis et n\'ayant pas validé le semestre après la 2ème session',
			resultatsNonAdmisSectionTitle: 'Liste des étudiants n\'ayant pas validé le semestre',
		}
	}

	return {
		feuilleDocumentTitle: 'Tableau des rattrapages',
		feuilleEmptyMessage: 'Aucun étudiant concerné par le rattrapage',
		feuilleModalTitle: 'Feuille de rattrapage',
		feuilleModalDescription: 'Tableau des étudiants concernés par le rattrapage, classés par EC',
		feuillePdfFilenamePrefix: 'Feuilles de rattrapages',
		resultatsModalDescription:
			'Liste des étudiants admis et allant en rattrapage (seuil de crédits insuffisant)',
		resultatsNonAdmisSectionTitle: 'Liste des étudiants allant en rattrapage',
	}
}

function extractNiveauFromSpecialite(specialite: string | undefined | null): string {
	const match = String(specialite ?? '').match(/(M[12]|L[123])/i)
	return match ? match[0].toUpperCase() : ''
}

export function buildFeuilleOutcomePdfFilename(deliberation: Deliberation): string {
	const labels = getDeliberationOutcomeDocumentLabels(deliberation.type_deliberation)
	const niveau = extractNiveauFromSpecialite(deliberation.specialite?.intitule)
	const sessionCode = deliberation.session?.code || deliberation.session?.nom || ''
	return `${labels.feuillePdfFilenamePrefix} - ${niveau}${sessionCode ? ' ' + sessionCode : ''}.pdf`
}

export function buildResultatsSessionPdfFilename(deliberation: Deliberation): string {
	const semestreNum = deliberation.semestre?.numero || ''
	const niveau = extractNiveauFromSpecialite(deliberation.specialite?.intitule)
	const sessionCode = deliberation.session?.code || deliberation.session?.nom || ''
	const typeSession = getDeliberationSessionLabel(deliberation.type_deliberation)
	return `Résultats ${typeSession} Semestre ${semestreNum} ${niveau}${sessionCode ? ' ' + sessionCode : ''}.pdf`
}
